// Base component (no leaf-theme override): the container is a bare div with no
// CSS-framework dependency, so every theme inherits this runtime unchanged.
const component = require('../component/component');

// An empty placeholder that receives dynamically-created components at runtime.
// The server renders it hidden (the theme's displayNone class sits in its
// component zone), so an empty container shows nothing; the first addComponent()
// reveals it and clear() hides it again. The grid cell around it keeps the
// container's configured span, so an added component is laid out at the
// container's span rather than its own.
const container = Object.assign({}, component, {
    notSubmittable: true,

    // Set by an inlineSurface that rendered itself in here, so clearing the container also
    // tears the surface down (it owns a body-level <form> that must go with it).
    hostedSurface: false,

    isEmpty: function () {
        return this.element.children.length === 0;
    },

    // Append-and-reveal primitive, without initing anything. Accepts an HTML string,
    // an element, or a component object (anything hm.app.addAction takes) and returns
    // the appended element, or null when it could not be resolved. Use this when the
    // caller inits the added markup itself (as the modal does, in one pass over the
    // whole modal element); use addComponent() otherwise.
    addElement: function (newComponent, prepend = false) {
        let element = newComponent;

        if (this.hm.helper.isString(element)) {
            element = this.hm.helper.string2element(element);
        } else if (element !== null && typeof element !== typeof undefined && typeof element.element !== typeof undefined) {
            element = element.element;
        }

        if (element === null || typeof element === typeof undefined || typeof element.dataset === typeof undefined) {
            return null;
        }

        if (prepend) {
            this.element.prepend(element);
        } else {
            this.element.appendChild(element);
        }

        this.hm.helper.showElement(this.element);

        return element;
    },

    // Add and init. Returns the ids of the components inited from the added markup.
    addComponent: function (newComponent) {
        let element = this.addElement(newComponent);

        if (element === null) {
            return [];
        }

        return this.initAdded(element);
    },

    // Accepts an array or an object of components/elements/HTML strings.
    addComponents: function (newComponents) {
        let inited = [];

        for (let key in newComponents) {
            inited = inited.concat(this.addComponent(newComponents[key]));
        }

        return inited;
    },

    // hm.app.initComponents() only walks a parent's *descendants*, so the added
    // element is registered on its own when it is itself a component root (it is
    // not when it comes wrapped in its componentHolder div).
    initAdded: function (element) {
        let inited = [];

        if (typeof element.dataset.zitComponent !== typeof undefined) {
            this.hm.app.newComponent(element.dataset.zitComponent, element.id, element);
            inited.push(element.id);
        }

        return inited.concat(this.hm.app.initComponents(element));
    },

    // Empty the container, deregister what was inside it, and hide it again.
    clear: function () {
        if (this.hostedSurface !== false) {
            // Detach before disposing: the surface's own dispose() calls back into clear().
            let hostedSurface = this.hostedSurface;
            this.hostedSurface = false;
            hostedSurface.dispose();
        }

        this.removeSubcomponents();
        this.element.replaceChildren();
        this.hm.helper.hideElement(this.element);
    },

    // Called by hm.app.removeComponents() when the container itself goes away —
    // and by clear(). Drops every component registered inside it (elementSubComponents
    // reports the container too, hence the own-id skip).
    removeSubcomponents: function () {
        let subComponentIds = this.hm.app.elementSubComponents(this.element).filter((componentId) => {
            return componentId !== this.id;
        });

        this.hm.app.removeComponents(subComponentIds);
    },

    getValue: function () {
        return null;
    },

    formPostData: function (formPostData) {
        return formPostData;
    }
});

module.exports = container;
